import { LineChart, LineChartProps } from '../../../renderers/line-chart/line-chart.component';
import { STOCK_VOLUME_BY_SPOT_LINE_CHART_DEFINITION } from './stock-volume-by-spot-line-chart.definition';
import { STOCK_VOLUME_BY_SPOT_LINE_CHART_MOCK_DATA } from './stock-volume-by-spot-line-chart.mock';

export const StockVolumeBySpotLineChart = (props: LineChartProps) => (
    <LineChart
        {...props}
        showArea
        chartOptions={{
            ...props.chartOptions,
            legend: {
                show: true,
                position: 'bottom',
                ...props.chartOptions?.legend
            }
        }}
    />
);

StockVolumeBySpotLineChart.definition = STOCK_VOLUME_BY_SPOT_LINE_CHART_DEFINITION;
StockVolumeBySpotLineChart.mockData = STOCK_VOLUME_BY_SPOT_LINE_CHART_MOCK_DATA;
